import {
  ExportType,
  MAIN_PACE_TASK_IDs,
  ProjectType,
} from '@symfa-inc/providence-verizon-types';
import { OptionProps } from '@models/interfaces';

export const ACCOUNTING_BROWSE_EMPTY_INVOICE_DATES: Record<string, undefined> =
  {
    [MAIN_PACE_TASK_IDs.leasingComplete]: undefined,
    [MAIN_PACE_TASK_IDs.siteAcqComplete]: undefined,
    [MAIN_PACE_TASK_IDs.candidateApproved]: undefined,
    [MAIN_PACE_TASK_IDs.zoningAppDeemedComplete]: undefined,
  };

export const getInvoiceDatePaceTaskIdOptions = (
  projectTypeMode: ProjectType,
): OptionProps[] => [
  ...(projectTypeMode === ProjectType.NSB
    ? [
        {
          viewValue: 'SS010 Invoice Date',
          value: MAIN_PACE_TASK_IDs.candidateApproved,
        },
      ]
    : []),
  {
    viewValue: 'RE015 Invoice Date',
    value: MAIN_PACE_TASK_IDs.leasingComplete,
  },
  {
    viewValue: 'RE020 Invoice Date',
    value: MAIN_PACE_TASK_IDs.siteAcqComplete,
  },
  ...(projectTypeMode === ProjectType.NSB
    ? [
        {
          viewValue: 'RE066 Invoice Date',
          value: MAIN_PACE_TASK_IDs.zoningAppDeemedComplete,
        },
      ]
    : []),
];

export const EXPORT_TYPE_BUTTONS: OptionProps[] = [
  { viewValue: '.csv', value: ExportType.CSV },
  { viewValue: '.xlsx', value: ExportType.XLSX },
];
